module.exports = __webpack_public_path__ + "img/chp-eat.60657866.png";